module.exports = __webpack_public_path__ + "img/star.dc55824e.png";